var address = "";
function fillAddressInput() {
    const addressInput = document.querySelector("#Home-capturedData-PolicyHolder-Address");
    if ( addressInput && document.activeElement.id !== 'Home-capturedData-PolicyHolder-Address' ) {
        addressInput.value = address;
    }
};

export { fillAddressInput }